import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { views, entities } from "../services/api";
import {
  BackIcon,
  GridViewIcon,
  HomeIcon,
  CameraIcon,
  PlusIcon,
  UserIcon,
} from "../components/Icons";
import SearchableSelect from "../components/SearchableSelect";

function CreateCustomView() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [rows, setRows] = useState(4);
  const [cols, setCols] = useState(3);
  const [parentId, setParentId] = useState("");
  const [locations, setLocations] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadLocations();
  }, []);

  const loadLocations = async () => {
    try {
      const { data } = await entities.list({ entity_type: "location" });
      setLocations(data);
    } catch (err) {
      console.error("Failed to load locations:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("Please enter a name");
      return;
    }

    if (rows < 1 || rows > 10 || cols < 1 || cols > 10) {
      alert("Rows and columns must be between 1 and 10");
      return;
    }

    setSaving(true);

    try {
      const config = {
        rows,
        cols,
        slots: [],
      };

      const { data } = await views.create({
        name: name.trim(),
        view_type: "grid",
        config,
        parent_id: parentId || null,
      });

      navigate(`/views/${data.id}`);
    } catch (err) {
      alert("Failed to create view");
      setSaving(false);
    }
  };

  // Preview grid
  const previewSlots = rows * cols;

  return (
    <div style={{ minHeight: "100vh", paddingBottom: "80px" }}>
      <div className="header">
        <div className="header-content">
          <button
            onClick={() => navigate("/views")}
            className="btn btn-ghost btn-icon"
          >
            <BackIcon size={20} />
          </button>
          <div className="header-text">
            <h1 className="header-title">Create View</h1>
            <p className="header-subtitle">
              Design a visual grid layout for your storage
            </p>
          </div>
        </div>
      </div>

      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="card">
            <label>View Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Garage Shelf"
              autoFocus
              className="mb-3"
            />

            <label>Parent Location (optional)</label>
            <SearchableSelect
              options={[{ id: "", name: "None" }, ...locations]}
              value={parentId}
              onChange={(val) => setParentId(val || "")}
              searchable
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.id}
            />

            <div className="grid grid-2">
              <div>
                <label>Columns</label>
                <input
                  type="number"
                  value={cols}
                  onChange={(e) =>
                    setCols(
                      Math.max(1, Math.min(10, parseInt(e.target.value) || 1)),
                    )
                  }
                  min="1"
                  max="10"
                />
              </div>
              <div>
                <label>Rows</label>
                <input
                  type="number"
                  value={rows}
                  onChange={(e) =>
                    setRows(
                      Math.max(1, Math.min(10, parseInt(e.target.value) || 1)),
                    )
                  }
                  min="1"
                  max="10"
                />
              </div>
            </div>
          </div>

          {/* Preview */}
          <div className="card">
            <h4 style={{ marginBottom: "var(--spacing-md)" }}>
              Preview ({cols}x{rows} = {previewSlots} slots)
            </h4>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${cols}, 1fr)`,
                gap: "var(--spacing-xs)",
                maxWidth: "300px",
                margin: "0 auto",
              }}
            >
              {Array.from({ length: previewSlots }).map((_, index) => (
                <div
                  key={index}
                  style={{
                    aspectRatio: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "var(--radius-sm)",
                    border: "2px dashed var(--border-color)",
                    background: "var(--bg-secondary)",
                    fontSize: "0.625rem",
                    color: "var(--text-muted)",
                  }}
                >
                  {index + 1}
                </div>
              ))}
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: "100%" }}
            disabled={saving}
          >
            {saving ? "Creating..." : "Create View"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateCustomView;
